import React from 'react';
import Date from '../../../../Components/Icons/Date';
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';

function Inspection() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/inspections-overview`);
  // const data = {
  //   total: 120,
  //   percentage: -8.5, 
  // };

  return (
    <div className="col-span-2 bg-gradient-to-br from-white to-gray-50 h-[22vh] w-full p-4 rounded-2xl shadow-lg  flex flex-col justify-between">
      
      {/* Header */}
      <div className="flex justify-between items-center">
        <h3 className="text-gray-700 text-sm font-semibold">Total Inspections</h3>
        <div className="bg-blue-100 text-blue-600 p-2 rounded-full shadow-sm">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
  <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z" />
</svg>

        </div>
      </div>

       <div>
        <p className="text-xl font-bold text-gray-800">{data?.total}</p>
        {/* <p className="text-xs text-gray-500">Completed inspections</p> */}
      </div>

      <div className="my-2">
  {typeof data?.percentage === 'number' && (
    <span
      className={`text-xs font-medium px-3 py-1 rounded-lg 
        ${data.percentage >= 0
          ? 'text-green-600 bg-green-100'
          : 'text-red-600 bg-red-100'
        }`}
    >
      {data.percentage >= 0 ? `+${data.percentage}% from last month` : `${data.percentage}% from last month`}
    </span>
  )}
</div>
    </div>
  );
}

export default Inspection;
